import React from "react";
import { Modal, Button, Result, Space, Typography, Divider } from "antd";

const { Text, Paragraph } = Typography;

interface PayConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  currentPayUrl: string;
  onConfirm: () => void;
}

const PayConfirmModal: React.FC<PayConfirmModalProps> = ({
  visible,
  onCancel,
  currentPayUrl,
  onConfirm,
}) => {
  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <i
            className="ri-secure-payment-line"
            style={{ fontSize: 22, marginRight: 12, color: "#1890ff" }}
          />
          <span style={{ fontSize: 18, fontWeight: 500 }}>支付确认</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={520}
      centered
      styles={{
        body: { padding: "24px", textAlign: "center" }
      }}
      className="pay-confirm-modal"
    >
      <Result
        icon={
          <i
            className="ri-information-line"
            style={{ fontSize: 64, color: "#1890ff" }}
          />
        }
        title="支付已发起"
        subTitle="请在新打开的窗口中完成支付"
        style={{ padding: 0, marginBottom: 16 }}
      />

      <Paragraph style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
        如果支付窗口没有自动打开，可以点击下方按钮重新打开支付页面。
      </Paragraph>

      <Divider plain style={{ margin: "16px 0" }}>
        <Text type="secondary">支付操作</Text>
      </Divider>

      <Space size="middle" style={{ marginTop: 16 }}>
        <Button
          onClick={() => window.open(currentPayUrl, "_blank")}
          icon={
            <i className="ri-external-link-line" style={{ marginRight: 6 }} />
          }
          size="large"
        >
          重新打开支付页面
        </Button>

        <Button
          type="primary"
          onClick={onConfirm}
          icon={<i className="ri-check-line" style={{ marginRight: 6 }} />}
          size="large"
        >
          我已完成支付
        </Button>
      </Space>

      <div
        style={{
          marginTop: 24,
          background: "#e6f7ff",
          padding: "12px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <i
          className="ri-lightbulb-flash-line"
          style={{ fontSize: 20, color: "#1890ff", marginRight: 12 }}
        />
        <div style={{ fontSize: 13, color: "#1890ff", textAlign: "left" }}>
          完成支付后请点击"我已完成支付"按钮刷新订单状态。如遇问题，请保留订单号联系客服。
        </div>
      </div>
    </Modal>
  );
};

export default PayConfirmModal;
